export default __webpack_public_path__ + "static/media/2018.b4e6d98c.png";